import React from "react";
import Icon from "../Icons/Icon";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaFacebookF, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { useContextHook } from "../../Context/ContextOPen";

const ContactIcons = ({ index }) => {
  const { swiperIndex } = useContextHook();
  return (
    <div
      className={
        "flex gap-5 py-1 pt-2 " +
        (swiperIndex === index ? " contactIcons " : "")
      }
    >
      <Icon
        href="https://www.linkedin.com/in/brabus-code-172a792b0"
        Icon={FaLinkedinIn}
      />
      <Icon
        href="https://www.facebook.com/profile.php?id=61556629956715"
        Icon={FaFacebookF}
      />
      <Icon href="whatsapp://send?phone=0968339368" Icon={FaWhatsapp} />
      <Icon
        href="https://www.instagram.com/codebrabus?igsh=MWFsd3ZxZTBlenBncQ=="
        Icon={FaInstagram}
      />
    </div>
  );
};

export default ContactIcons;
